/**
 @ngdoc directive
 @name xmsListing

 @param {number} auto-refresh autorefresh listing every number of seconds (default 300s/5min)
 @param {Object} defaults default options { sort: 'createTime' | 'piority', resultsPerPage: number, pageNumber: number }
 @param {boolean=} json json only listing

 @usage
 */
(function() {
    'use strict';

    var xmsListing = function($timeout, $sce, $filter, $templateCache, $translatePartialLoader, ajaxCall, errorMsgFactory) {
        return {
            restrict: "EA",
            scope: true,
            bindToController: {
                /*  '@' Text binding  '=' Two-way binding  '&' Method binding  '<' One-way binding  */
                baseUrl:      '@',
                listingModel: '=xmsListing',
                autoRefresh:  '@',
                defaults:     '&',
                searchUrl:    '@',
                json:         '@',
                id:           '@'
            },
            controllerAs: 'ctrl',
            controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs){
                var _this = this;
                var defaults;

                this.$onInit = function(){
                    if( !angular.isDefined(_this.listingModel) ){
                        _this.listingModel={};
                    }

                    $scope.json = angular.isDefined(_this.json) && _this.json === 'true' ? true : false;

                    // init
                    defaults                     = angular.isDefined( this.defaults() )         ? this.defaults()         : {};
                    this.listingModel.defaults       = defaults;

                    this.listingModel.sort           = angular.isDefined( defaults.sort )       ? defaults.sort           : null;
                    this.listingModel.resultsPerPage = angular.isDefined( defaults.resultsPerPage ) ? defaults.resultsPerPage : '10';

                    this.listingModel.order          = 'desc';

                    this.listingModel.refresh        =  0;

                    // set to undefined because the init value is set by watcher in xmsListing.html
                    this.listingModel.pageNumber     = undefined;

                    this.listingModel.loadedTags = 0;
                    this.listingModel.maxPagesToDisplay = 10000;
                };

                // helper function to init page number correctly
                this.initPageNumberFromDefaultsOrAssignCurrentValueNotGreaterThanMaxPageNumber = function(pageNumber, maxPages, defaults) {
                    if(pageNumber == null) {
                        // X3-24792 show saved page number if one exists
                        const savedPageNumber = +sessionStorage.getItem(this.id);
                        if(savedPageNumber) {
                            return savedPageNumber
                        }
                        // init from given defaults or set to first page (1)
                        return defaults != null && defaults.pageNumber != null ? defaults.pageNumber : 1
                    } else if (pageNumber > maxPages && maxPages > 0) {
                        // page number cannot be greater than max page
                        return maxPages;
                    } else {
                        // otherwise return current pageNumber
                        return pageNumber;
                    }
                };

                $scope.Math = window.Math;
            }],
            replace: true,
            transclude: false,
            template: $templateCache.get('components/listing/xmsListing.html'),
            require: 'xmsListing',
            link: function(scope, element, attrs, ctrl) {

                // translation
                $translatePartialLoader.addPart('listing');

                var ajaxRequest;

                // at first time the listing is rendered by backend (so it's quick)
                ctrl.listingModel.firstLoadByBackend        = true;
                ctrl.listingModel.firstDynamicLoadFinished  = false;
                var firstLoadWatchCancel = scope.$watch('ctrl.listingModel.loading', function(newVal, oldVal){
                    if(newVal !== undefined){ // at first listingModel.loading is undefined
                        ctrl.listingModel.firstLoadByBackend = false;
                    }
                    if(newVal==false) {
                        ctrl.listingModel.firstDynamicLoadFinished = true;
                        firstLoadWatchCancel(); // we don't need this watch as soon as we start using js for loading listing
                    }
                });


                $timeout(function(){

                    scope.$watch(
                        function(){
                            return {
                                'uId'                 : ctrl.listingModel.uId,
                                'sort'                : ctrl.listingModel.sort,
                                'order'               : ctrl.listingModel.order,
                                'resultsPerPage'      : ctrl.listingModel.resultsPerPage,
                                'jobRadius'           : ctrl.listingModel.jobRadius,
                                'pageNumber'          : ctrl.listingModel.pageNumber,
                                // watch only for filters set to true // TODO: replace with underscore _.pick function
                                'filters'             : trueOnly(ctrl.listingModel.filters), //(ctrl.listingModel.filters!==undefined) ? _.pick( ctrl.listingModel.filters, function(value, key, object) {return value;}) : '',
                                'refresh'             : ctrl.listingModel.refresh,
                                'viewedBy'            : ctrl.listingModel.viewedBy,
                                //'viewedByPerson': ctrl.listingModel.viewedByPerson,
                                'viewedWithinRefresh' : ctrl.listingModel.viewedWithinRefresh,
                                'viewedWithinFrom'    : ctrl.listingModel.viewedWithinFrom,
                                'viewedWithinTo'      : ctrl.listingModel.viewedWithinTo,
                                'keywordFilter'       : ctrl.listingModel.keywordFilter,
                                'lockToMyOu'          : ctrl.listingModel.lockToMyOu,
                                'favouritesOnly'      : ctrl.listingModel.favouritesOnly,
                                'myRemit'      : ctrl.listingModel.myRemit,
                                'radius'              : ctrl.listingModel.radius
                            };
                        },
                        function(newVal, oldVal){
                            savePageNumber(ctrl.listingModel.pageNumber)
                            // X3-19819
                            try {
                                var refineForm = document.querySelector('#ListScreenForm')
                                if (refineForm) {
                                    var lockToMyOu = refineForm.querySelector('input[name=lockToMyOu]')
                                    if (lockToMyOu) {
                                        lockToMyOu.value = newVal.lockToMyOu
                                    }
                                    var favouritesOnly = refineForm.querySelector('input[name=favouritesOnly]')
                                    if (favouritesOnly) {
                                        favouritesOnly.value = newVal.favouritesOnly
                                    }
                                    var myRemit = refineForm.querySelector('input[name=myRemit]')
                                    if (myRemit) {
                                        myRemit.value = newVal.myRemit
                                    }
                                }
                            } catch (e) {
                            }
                            if(newVal != oldVal){

                                if(newVal.pageNumber != 1){
                                    // on most of the actions we want to set the pageNumber to 1
                                    // so we can compare newVal and oldVal
                                    var newValCopy = angular.copy(newVal);
                                    var oldValCopy = angular.copy(oldVal);
                                    // with some adjustments:
                                    // - not on refresh
                                    delete newValCopy.refresh;
                                    delete oldValCopy.refresh;
                                    // - for comparison we need to of course remove pageNumber
                                    delete newValCopy.pageNumber;
                                    delete oldValCopy.pageNumber;

                                    if( !angular.equals(newValCopy, oldValCopy) ){
                                        ctrl.listingModel.pageNumber = 1;
                                        return; // the above will trigger one more watch so we can exit here
                                    }
                                }

                                // do not do anything on filters initial load (first change)
                                if(!angular.isDefined(ctrl.listingModel.filtersInitiallyLoaded) || !ctrl.listingModel.filtersInitiallyLoaded){
                                    if(newVal.filters!=oldVal.filters){
                                        console.info('xmsListing cancelled on first filters change (filters load).');
                                        return;
                                    }
                                }

                                // scrolling back to the top on page change (but not once we change filters)
                                if( newVal.pageNumber!=oldVal.pageNumber && angular.equals(newVal.filters, oldVal.filters) ) {
                                    scrollTop(250);
                                }

                                // Advanced search uses the different url for filters and listing
                                // So, passing the new search url for listing page to load
                                var baseUrl = ctrl.baseUrl;
                                if(angular.isDefined(ctrl.searchUrl)){
                                    if( newVal.resultsPerPage != oldVal.resultsPerPage ||
                                        newVal.pageNumber != oldVal.pageNumber ||
                                        newVal.sort != oldVal.sort ||
                                        newVal.order != oldVal.order ) {
                                        baseUrl = ctrl.searchUrl;
                                    }
                                }

                                // cancel previous autorefresh (the new timer will be set upon successful request)
                                if( angular.isDefined(ctrl.autoRefresh) ) {
                                    $timeout.cancel(scope.autoRefreshTimeout);
                                }

                                // dim the listing while loading - this might have been also achived with ng-style on .listResults
                                // ng-style="listingModel.loading===true ? {'opacity':'0.4'} : {}"
                                var listResults = element.find('ul.listResults');
                                if(!listResults.length){
                                    listResults = element.parent().find('ul.listResults');
                                }
                                // TODO: temporarily removed - build opacity back into new search tile display function
                                // listResults.css('opacity','0.4');


                                // disable tick-all while loading
                                ctrl.listingModel.disableOnLoad++;

                                // Resetting the number of loaded tags
                                ctrl.listingModel.loadedTags = 0;


                                /*console.log('ctrl.listingModel.filters');
                                console.log(ctrl.listingModel.filters);
                                console.log(jQuery.param(ctrl.listingModel.filters));*/


                                scope.query = [
                                    // '&hdnLastVisitedController=activityCentre', // now moved to gsp
                                    // '&hdnLastVisitedAction=list', // now moved to gsp
                                    '&universalIdfilter='+(angular.isDefined(ctrl.listingModel.uId) ? ctrl.listingModel.uId : ''),
                                    '&changePageTop=1',
                                    '&changePageBottom=1',
                                    '&sort='+ctrl.listingModel.sort,
                                    '&order='+ctrl.listingModel.order,
                                    '&max='+ctrl.listingModel.resultsPerPage,
                                    '&jobRadius='+ctrl.listingModel.jobRadius,
                                    '&offset='+(( (ctrl.listingModel.pageNumber>0) ? ctrl.listingModel.pageNumber-1:0)*ctrl.listingModel.resultsPerPage),
                                    '&filterUserAction=true&'+jQuery.param(ctrl.listingModel.filters),
                                    '&hdnIsLoaded=true',
                                    '&filterUserActionChange=true',
                                    '&refresh='+(angular.isDefined(ctrl.listingModel.refresh)?ctrl.listingModel.refresh : ''),
                                    (angular.isDefined(ctrl.listingModel.viewedBy)?'&viewedBy='+ctrl.listingModel.viewedBy : ''),
                                    (angular.isDefined(ctrl.listingModel.viewedByPerson)?'&viewedByPerson='+ctrl.listingModel.viewedByPerson : ''),
                                    (angular.isDefined(ctrl.listingModel.viewedWithin)?'&viewedWithin='+ctrl.listingModel.viewedWithin : ''),
                                    (angular.isDefined(ctrl.listingModel.viewedWithinFrom)?'&viewedWithinFrom='+ $filter('date')(new Date(ctrl.listingModel.viewedWithinFrom), 'yyyy-MM-dd') : ''),
                                    (angular.isDefined(ctrl.listingModel.viewedWithinFrom)?'&viewedWithinFromDate='+ $filter('date')(new Date(ctrl.listingModel.viewedWithinFrom), 'yyyy-MM-dd') : ''),
                                    (angular.isDefined(ctrl.listingModel.viewedWithinTo)?'&viewedWithinTo='+$filter('date')(new Date(ctrl.listingModel.viewedWithinTo), 'yyyy-MM-dd') : ''),
                                    (angular.isDefined(ctrl.listingModel.viewedWithinTo)?'&viewedWithinToDate='+$filter('date')(new Date(ctrl.listingModel.viewedWithinTo), 'yyyy-MM-dd') : ''),
                                    (angular.isDefined(ctrl.listingModel.viewedWithinLast)?'&viewedWithinLast='+ctrl.listingModel.viewedWithinLast : ''),
                                    (angular.isDefined(ctrl.listingModel.keywordFilter)?'&keywordFilter='+ctrl.listingModel.keywordFilter+'&keywordFilterUsed=true' : ''),
                                    //(angular.isDefined(ctrl.listingModel.searchInputCookie)?'&searchInputCookie='+ctrl.listingModel.searchInputCookie : ''),
                                    (angular.isDefined(ctrl.listingModel.hiddenParams)?'&'+jQuery.param(ctrl.listingModel.hiddenParams) : ''),
                                    (angular.isDefined(ctrl.listingModel.lockToMyOu)?'&lockToMyOu='+ctrl.listingModel.lockToMyOu : ''),
                                    (angular.isDefined(ctrl.listingModel.favouritesOnly)?'&favouritesOnly='+ctrl.listingModel.favouritesOnly : ''),
                                    (angular.isDefined(ctrl.listingModel.myRemit)?'&myRemit='+ctrl.listingModel.myRemit : ''),
                                    (angular.isDefined(ctrl.listingModel.radius)?'&radius='+ctrl.listingModel.radius : ''),

                                ].join('');

                                scope.searchQuery = [
                                    (angular.isDefined(ctrl.listingModel.viewedBy)?'&searchFieldIdObject1='+ctrl.listingModel.viewedBy : ''),
                                    (angular.isDefined(ctrl.listingModel.viewedByPerson)?'&fieldValue_1='+ctrl.listingModel.viewedByPerson : ''), //Missing functionality inside method
                                    (angular.isDefined(ctrl.listingModel.viewedWithin)?'&fieldValueWithin_1='+ctrl.listingModel.viewedWithin : ''),
                                    (angular.isDefined(ctrl.listingModel.viewedWithinFrom)?'&from_fieldValue_1_display='+ctrl.listingModel.viewedWithinFrom : ''),

                                    //'&searchControl_1=595', // Unique & Static (always "is" in filters options)
                                    '&from_fieldValue_1=date.struct', // Unique
                                    //'&searchFieldId_1=1927', // Unique
                                    '&isGlobalSearch=true',
                                    (angular.isDefined(ctrl.listingModel.keywordFilter)?'&keywordFilter='+ctrl.listingModel.keywordFilter+'&keywordFilterUsed=true' : ''),

                                    (angular.isDefined(ctrl.listingModel.viewedWithinFrom)?'&from_fieldValue_1_year='+ $filter('date')(new Date(ctrl.listingModel.viewedWithinFrom), 'yyyy') : ''),
                                    (angular.isDefined(ctrl.listingModel.viewedWithinFrom)?'&from_fieldValue_1_month='+ $filter('date')(new Date(ctrl.listingModel.viewedWithinFrom), 'M') : ''),
                                    (angular.isDefined(ctrl.listingModel.viewedWithinFrom)?'&from_fieldValue_1_day='+ $filter('date')(new Date(ctrl.listingModel.viewedWithinFrom), 'd') : ''),

                                    '&to_fieldValue_1=date.struct',
                                    (angular.isDefined(ctrl.listingModel.viewedWithinTo)?'&to_fieldValue_1_display='+ctrl.listingModel.viewedWithinTo : ''),

                                    (angular.isDefined(ctrl.listingModel.viewedWithinTo)?'&to_fieldValue_1_year='+ $filter('date')(new Date(ctrl.listingModel.viewedWithinTo), 'yyyy') : ''),
                                    (angular.isDefined(ctrl.listingModel.viewedWithinTo)?'&to_fieldValue_1_month='+ $filter('date')(new Date(ctrl.listingModel.viewedWithinTo), 'M') : ''),
                                    (angular.isDefined(ctrl.listingModel.viewedWithinTo)?'&to_fieldValue_1_day='+ $filter('date')(new Date(ctrl.listingModel.viewedWithinTo), 'd') : ''),

                                    '&rowid=1', // Not sure if necessary
                                    //'&searchFieldIdDisplay1=1927' // Not sure if necessary
                                ].join('');

                                // Todo: missing "custom" in advanced search, might be missing in search method too

                                ctrl.listingModel.searchQuery = scope.searchQuery;
                                ctrl.listingModel.isError = false;
                                ctrl.listingModel.loading = true;

                                // abort previous request if it's still being processed
                                // (otherwise it could be returned even later than the current request!)
                                if( angular.isDefined(ajaxRequest) && ajaxRequest.abort!==angular.noop ){
                                    console.info('Early new request - aborting previous request.');
                                    ajaxRequest.abort(); // cancel previous request
                                }

                                // request
                                ajaxRequest = ajaxCall.getData(baseUrl,scope.query);
                                ajaxRequest.then(
                                    function(result) {
                                        ctrl.listingModel.loading = false;
                                        ctrl.listingModel.tilesData = {}; // empty tilesData on each listing (re)load
                                        // if(!scope.json){ // still (temporarily) needs to render <get-tiles-data>
                                        scope.listingHtml = $sce.trustAsHtml( angular.copy(result.data) );
                                        // }

                                        if( angular.isDefined(ctrl.autoRefresh) ){
                                            scope.autoRefresh();
                                        }
                                    },
                                    function(result) {
                                        if(result.status!==-1){ // if not aborted / cancelled
                                            ctrl.listingModel.loading = false;
                                            ctrl.listingModel.isError = true;
                                            ctrl.listingModel.errorMsg = $sce.trustAsHtml( errorMsgFactory.connectionError(result) );
                                        }
                                    }
                                );


                            }
                        }, true // deep watch
                    );

                    // for more watches see the template
                });


                // auto refresh functionality
                if( angular.isDefined(ctrl.autoRefresh) ) {

                    var autoRefreshTime = ctrl.autoRefresh;
                    if( autoRefreshTime == '' ) {
                        autoRefreshTime = 300; // 5 min by default // TODO: some settings/config
                    }

                    scope.autoRefresh = function(){
                        scope.autoRefreshTimeout = $timeout(function(){
                            ctrl.listingModel.refresh++;
                        }, (autoRefreshTime*1000) );
                    }
                    scope.autoRefresh();
                }


                element.on('$destroy', function(){
                    if( angular.isDefined(ctrl.autoRefresh) ) {
                        $timeout.cancel(scope.autoRefreshTimeout);
                    }
                    ctrl.listingModel = {};
                });

                // TODO: replace with underscore _.pick function
                // Added further checks to avoid watch trigger when all filter values are checked
                function trueOnly(obj){
                    var result = {};

                    angular.forEach(obj, function(val, key){
                        if(val===true || val==='true'){
                            result[key]=val;

                        }
                    });
                    // Return empty object if all filters true or all filters false inside separate filter groups,
                    // this is to avoid watch trigger when filter values are loaded as all true.
                    return result;

                }

                /**
                 * Helper function that returns a key to identify group of filters
                 * @param key
                 * @returns {*}
                 */
                var getSpecificFilterKey = function(key) {
                    // Check if key has | in it's string value
                    if (key.indexOf('|') > -1)
                    {
                        // matching first part of the key until first character '|' that groups specific filter groups.
                        var specificFilterKey = key.match(/[^\|]*/)[0];
                        // Removing '!' in front of the key
                        specificFilterKey = specificFilterKey.charAt(0) === '!' ? specificFilterKey.substr(1) : specificFilterKey;
                    } else {
                        // matching first part of the key until first character '_' that groups specific filter groups.
                        var specificFilterKey = key.match(/[^\_]*/)[0];
                    }
                    return specificFilterKey;
                };

                var scrollTop = function(timeMs){
                    $('body,html').animate({ scrollTop: 0}, timeMs, 'swing');
                }

                const savePageNumber = (number) => {
                    if(!attrs.rememberPageIndex) return;
                    // parse value to ensure it is evaluated as a boolean
                    if(JSON.parse(attrs.rememberPageIndex)) {
                        sessionStorage.setItem(attrs.id, number);
                    } else {
                        // if a session value exists but rememberPageIndex is false, remove it
                        sessionStorage.removeItem(attrs.id);
                    }
                }

            }
        };
    };
    xmsListing.$inject = ['$timeout', '$sce', '$filter', '$templateCache', '$translatePartialLoader', 'ajaxCall', 'errorMsgFactory'];
    angular.module('app').directive('xmsListing', xmsListing);

}());
